import React, {useState} from "react";
import { Input as AntInput } from 'antd';

const componentClass = 'fieldType__password';

const Input = ({ onChange, value, ...rest }) => {

  return <AntInput.Password
      className={componentClass}
      onChange={e => onChange(e.target.value)}
      value={value}
      {...rest}
  />
}
export default Input;
